import { render } from "./ProductsRelatedAuto.vue?vue&type=template&id=c355cca4"
import script from "./ProductsRelatedAuto.vue?vue&type=script&lang=js"
export * from "./ProductsRelatedAuto.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__